export default {
  actionsContainer: {
    marginTop: 2,
    marginRight: 8
  },
  actionButton: {
    width: 36,
    height: 36
  },
  search: {
    minWidth: 300,
    margin: "0 16px 8px"
  },
  dialogContent: {
    minWidth: 300,
    padding: 0
  },
  errorText: {
    color: "#FF0014",
    marginTop: 0,
    paddingTop: "0.4em",
    fontSize: "0.8em",
    fontFamily: "Source Sans Pro",
    whiteSpace: "pre-line"
  },
  textFieldContainer: {
    margin: "12px 0 0"
  },
  productField: {
    width: "100%",
    cursor: "pointer",
    height: 30,
    padding: 5,
    backgroundColor: "#f7f7f7",
    border: "1px solid #ddd"
  },
  dummyIcon: {
    fontSize: "30px",
    fontWeight: "bold",
    color: "red"
  }
};



// WEBPACK FOOTER //
// ./src/components/support/entity-selector/styles.js